import Choices from 'choices.js';

document.addEventListener('DOMContentLoaded', function () {
	const element = document.getElementById('selectClient');

	if (!element) {
		return;
	}

	new Choices(element, {
		searchEnabled: true,
		placeholderValue: 'Select an option',
		searchPlaceholderValue: 'Search clients...',
		position: 'bottom',  // Always open downward to keep search visible
	});
});

